import {
  ICountry,
  ICountryEmailRecipient,
  ICountryEmailRecipientCreatePayload,
  ICountryEmailRecipientData,
  ICountryEmailRecipientUpdatePayload,
} from '../interfaces/Country.interface';
import { IOptions } from '../interfaces/Form-Modal.interface';
import { axiosAuthInstance } from './Auth.service';

// Get Countries
export const GetCountries = async (): Promise<IOptions[]> => {
  const client = await axiosAuthInstance();

  const response = await client.get('/user/countries');
  return response.data.countries.filter((country: string | null) => country !== null).map((country: string) => {
      return {
        label: country,
        value: country,
      }
  });
};

export const GetCountryList = async (): Promise<ICountry[]> => {
  const client = await axiosAuthInstance();
  const response = await client.get('/country/list');
  return response.data.data;
};

export const GetCountry = async (id: string): Promise<ICountry> => {
  const client = await axiosAuthInstance();
  const response = await client.get(`/country/${id}`);
  return response.data;
};

/**
 * Country Email Recipient
 */

export const getCountryEmailRecipientList = async (
  countryId: string,
  limit: number,
  offset: number
): Promise<ICountryEmailRecipientData> => {
  const client = await axiosAuthInstance();
  const response = await client.get(
    `/country-email-recipient/country/${countryId}?limit=${limit}&offset=${offset}`
  );

  return {
    ...response.data,
    nextLink: response.data.pagination?.nextLink,
  };
};

/**
 * Looks recipients up by country name rather than id, for callers that only know
 * the raw name carried by a preload check. Casing and spacing are normalized
 * server side, so any variant resolves to the same country.
 */
export const getCountryEmailRecipientListByName = async (
  name: string
): Promise<ICountryEmailRecipientData> => {
  const client = await axiosAuthInstance();
  const response = await client.get(
    `/country-email-recipient/by-country-name/${encodeURIComponent(name)}`
  );

  return {
    ...response.data,
    nextLink: response.data.pagination?.nextLink,
  };
};

export const createCountryEmailRecipient = async (
  payload: ICountryEmailRecipientCreatePayload
): Promise<void> => {
  const client = await axiosAuthInstance();
  const response = await client.post('/country-email-recipient', payload);
  return response.data;
};

export const editCountryEmailRecipient = async (
  id: string,
  payload: ICountryEmailRecipientUpdatePayload
): Promise<ICountryEmailRecipient> => {
  const client = await axiosAuthInstance();
  const response = await client.put(`/country-email-recipient/${id}`, payload);
  return response.data;
};

export const deleteCountryEmailRecipient = async (id: string): Promise<void> => {
  const client = await axiosAuthInstance();
  const response = await client.delete(`/country-email-recipient/${id}`);
  return response.data;
};
